
import Card from '../../../components/base/Card';

export default function Features() {
  const features = [
    {
      icon: 'ri-mind-map',
      title: '可视化知识图谱',
      description: '直观展示知识点之间的关联关系，帮助学生构建完整的知识体系',
      color: 'bg-blue-500'
    },
    {
      icon: 'ri-route-line',
      title: '个性化学习路径',
      description: '根据学生基础和目标，智能推荐最适合的学习路径和课程安排',
      color: 'bg-green-500'
    },
    {
      icon: 'ri-database-2-line',
      title: '大数据技术应用',
      description: '结合最新的大数据技术，提升财税数据分析和处理能力',
      color: 'bg-purple-500'
    },
    {
      icon: 'ri-robot-line',
      title: '智能财税实训',
      description: '通过智能化工具和机器人技术，提供真实的财税业务实训环境',
      color: 'bg-orange-500'
    },
    {
      icon: 'ri-team-line',
      title: '协作学习模式',
      description: '支持小组协作学习，培养团队合作能力和沟通技巧',
      color: 'bg-teal-500'
    },
    {
      icon: 'ri-award-line',
      title: '能力认证体系',
      description: '完善的能力评估和认证体系，为学生提供权威的技能证明',
      color: 'bg-red-500'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            平台特色功能
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            创新的教学方法和先进的技术手段，为财税大数据专业教育提供全方位支持
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card key={index} hover className="text-center">
              <div className={`w-16 h-16 ${feature.color} rounded-full flex items-center justify-center mx-auto mb-4`}>
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
            </Card>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-6 text-white">
            <h3 className="text-2xl lg:text-3xl font-bold mb-2">财税行业动态</h3>
            <p className="text-lg opacity-90">紧跟行业前沿，掌握最新政策动态，确保教学内容的时效性和实用性</p>
          </div>
          
          <div className="p-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {/* Latest Policy Updates */}
              <div className="lg:col-span-2">
                <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-newspaper-line text-blue-600 mr-2"></i>
                  最新政策解读
                </h4>
                <div className="space-y-4">
                  {[
                    {
                      title: '2024年增值税改革新政策解读',
                      summary: '财政部发布最新增值税征收管理办法，涉及数字经济、跨境电商等新业态税收政策调整',
                      date: '2024-01-15',
                      tag: '政策解读',
                      importance: 'high',
                      icon: 'ri-government-line'
                    },
                    {
                      title: 'AI在财务审计中的应用趋势',
                      summary: '人工智能技术在财务审计领域的深度应用，智能风险识别、自动化审计程序等技术突破',
                      date: '2024-01-12',
                      tag: '技术前沿',
                      importance: 'medium',
                      icon: 'ri-robot-line'
                    },
                    {
                      title: '碳税征收试点方案正式启动',
                      summary: '国家发改委联合财政部发布碳税征收试点实施方案，标志着我国绿色税收体系建设进入新阶段',
                      date: '2024-01-08',
                      tag: '政策动态',
                      importance: 'high',
                      icon: 'ri-leaf-line'
                    }
                  ].map((news, index) => (
                    <div key={index} className="border-l-4 border-blue-500 pl-4 hover:bg-gray-50 transition-colors duration-200 rounded-r-lg p-3">
                      <div className="flex items-start gap-3">
                        <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-white ${
                          news.importance === 'high' ? 'bg-red-500' : 'bg-blue-500'
                        }`}>
                          <i className={`${news.icon} text-sm`}></i>
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2 mb-1">
                            <h5 className="font-semibold text-gray-900 text-sm hover:text-blue-600 cursor-pointer">
                              {news.title}
                            </h5>
                            <span className={`px-2 py-1 text-xs rounded-full ${
                              news.importance === 'high' 
                                ? 'bg-red-100 text-red-800' 
                                : 'bg-blue-100 text-blue-800'
                            }`}>
                              {news.tag}
                            </span>
                          </div>
                          <p className="text-gray-600 text-xs mb-2 leading-relaxed">
                            {news.summary}
                          </p>
                          <div className="flex items-center justify-between">
                            <span className="text-xs text-gray-500">{news.date}</span>
                            <button className="text-blue-600 hover:text-blue-800 text-xs font-medium">
                              阅读全文 <i className="ri-arrow-right-line ml-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Industry Stats & Quick Actions */}
              <div className="space-y-4">
                {/* Policy Updates Counter */}
                <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-4 text-center">
                  <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-file-text-line text-xl text-white"></i>
                  </div>
                  <h5 className="font-bold text-gray-900 mb-1 text-sm">本月政策更新</h5>
                  <div className="text-2xl font-bold text-green-600 mb-1">12</div>
                  <p className="text-xs text-gray-600">项重要政策发布</p>
                </div>

                {/* Hot Trends */}
                <div className="bg-gray-50 rounded-xl p-4">
                  <h5 className="font-bold text-gray-900 mb-3 text-sm flex items-center">
                    <i className="ri-fire-line text-red-500 mr-1"></i>
                    热门趋势
                  </h5>
                  <div className="space-y-2">
                    {[
                      { trend: '数字化财务管理', heat: 95 },
                      { trend: 'ESG财务披露', heat: 88 },
                      { trend: '智能税务筹划', heat: 82 }
                    ].map((item, index) => (
                      <div key={index} className="flex items-center justify-between">
                        <span className="text-xs font-medium text-gray-900">{item.trend}</span>
                        <div className="flex items-center gap-1">
                          <div className="w-12 bg-gray-200 rounded-full h-1">
                            <div 
                              className="bg-gradient-to-r from-blue-500 to-purple-500 h-1 rounded-full"
                              style={{ width: `${item.heat}%` }}
                            ></div>
                          </div>
                          <span className="text-xs text-gray-500">{item.heat}%</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Quick Actions */}
                <div className="space-y-2">
                  <button className="w-full text-left p-3 rounded-lg bg-blue-50 hover:bg-blue-100 transition-colors group">
                    <div className="flex items-center gap-2">
                      <i className="ri-notification-line text-blue-600 text-sm group-hover:scale-110 transition-transform"></i>
                      <span className="font-medium text-blue-900 text-xs">订阅政策推送</span>
                    </div>
                  </button>
                  <button className="w-full text-left p-3 rounded-lg bg-green-50 hover:bg-green-100 transition-colors group">
                    <div className="flex items-center gap-2">
                      <i className="ri-calendar-line text-green-600 text-sm group-hover:scale-110 transition-transform"></i>
                      <span className="font-medium text-green-900 text-xs">行业会议日程</span>
                    </div>
                  </button>
                </div>
              </div>
            </div>

            {/* Bottom CTA */}
            <div className="mt-6 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-xl p-6 text-white text-center">
              <h4 className="text-lg font-bold mb-2">紧跟行业脉搏，引领财税未来</h4>
              <p className="text-sm mb-4 opacity-90">我们的教学内容与行业发展同步更新，确保学生掌握最前沿的财税知识</p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <button className="bg-white text-indigo-600 px-6 py-2 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer text-sm">
                  <i className="ri-eye-line mr-2"></i>
                  查看更多动态
                </button>
                <button className="border-2 border-white text-white px-6 py-2 rounded-lg font-semibold hover:bg-white hover:text-indigo-600 transition-colors whitespace-nowrap cursor-pointer text-sm">
                  <i className="ri-rss-line mr-2"></i>
                  订阅资讯
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
